<template>
  <div v-if="subjects">
    <div class="page-title"> 교과별 계획 </div>
    <div class="mt-3">
      <folder-label v-if="subjects.NCS && subjects.NCS.length" label="NCS 교과" :open="true">
        <div v-for="s in subjects.NCS" :key="s._id" class="ml-4 pointer"
          @click="onViewPlan(s)">
          <mdb-icon  icon="chalkboard-teacher" /> {{s.name}}
        </div>
      </folder-label>
      <folder-label v-if="subjects.NONNCS && subjects.NONNCS.length" label="비 NCS 교과" :open="true" >
        <div v-for="s in subjects.NONNCS" :key="s._id" class="ml-4 pointer"
          @click="onViewPlan(s)"
          :style="active(s)">
          <mdb-icon  icon="chalkboard-teacher" /> {{s.name}}
        </div>
      </folder-label>
      <hr/>
      <subject-plan v-if="subject" :plan="subject.plan" :lectures="subject.lectures" />
    </div>
  </div>
</template>
<script>
import { mdbTabs } from 'mdbvue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import Training from '@/models/Training'
import SubjectPlan from '../../../components/subject/SubjectPlan.vue'
import FolderLabel from '../../../components/common/FolderLabel.vue'
export default {
  name: 'TrainingPlan',
  components: { FolderLabel, SubjectPlan },
  data () {
    return {
      TAG: 'TrainingPlan >>',
      subject: undefined
    }
  },
  computed: {
    ...mapState('training', ['subjects'])
  },
  methods: {
    onViewPlan (s) {
      this.subject = s
    },
    active (subject) {
      return subject !== this.subject ? {} : {
        'font-weight': 900,
        color: 'black' // '#0d47a1'
      }
    }
  }
}
</script>
